/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { Button, Grid, Chip, Typography, IconButton } from '@mui/material'
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import FormikAutocomplete from '../../../../components/inputs/FormikAutoComplete';
import { Field } from 'formik';
import FormikInputTest from '../../../../components/inputs/FormikInputTest';
import { useFormikContext } from "formik";
import FormikDataPicker from '../../../../components/inputs/FormikDataPicker';
import "react-datepicker/dist/react-datepicker.css";
import { getCurrencies } from '../../../../Store/Ducks/duckCurrencies';
import { getReasons } from '../../../../Store/Ducks/duckReason';
import { postSendDocumentXml } from '../../../../Store/Ducks/duckDocumentXml'
import BackupIcon from "@mui/icons-material/Backup";
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import Dropzone from "react-dropzone";
import { useSnackbar } from "notistack";
import { snackAction } from '../../../../components/CustomSnakbar';
import CustomSnackbarCollapse from '../../../../components/CustomSnackbarCollapse';
import { TextFieldWithEraser } from '../../../../components/inputs/TextFieldWithEraser';
import RelatedInvoicePopup from '../../../../components/ui/RelatedInvoicePopup';
import { DOCUMENT_INVOICE_MASK } from '../../../../constants';
import "../../../../Styles/uploadFiles.css";

const useStyles = makeStyles((theme) => ({
    button: {
        height: "55px",
        width: "75px",
    }
}));

const CompanyToInvoice = (props) => {

    const { documentType } = props
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [relatedInvoice, setRelatedInvoice] = useState('');
    const [allRelatedInvoice, setAllRelatedInvoice] = useState([])
    const [editCuit, setEditCuit] = useState(false)
    const [exchangeRateDisabled, setExchangeRateDisabled] = useState(false)
    const [xmlValuesDisabled, setXmlValuesDisabled] = useState(false)
    const [disabledRelatedInvoice, setDisabledRelatedInvoice] = useState(false)
    const { setFieldValue, values } = useFormikContext()
    const email = useSelector(store => store.authentication?.authenticatedUser?.email)
    const country = useSelector(store => store.countries?.data.find(item => item.selected));
    const validateXmlInvoice = useSelector(store => store.countries?.data.find(item => item.selected)?.validateXmlInvoice);
    const xmlValues = useSelector(store => store.documentXml.data)
    const societies = useSelector(store => store.societies.data.filter(x => x.selected).sort((a, b) => a.nif.localeCompare(b.nif)).map(
        ({ id, nif, description }) => ({
            label: `${nif} - ${description}`,
            id,
        })
    ))
    const availablesCUIT = useSelector(store => store.supplier?.data?.availablesCUIT)

    const currencies = useSelector(store => store.currencies.data.map(
        ({ id, code, countryId }) => ({
            label: code,
            id,
            countryId
        })
    ))

    const reasons = useSelector(store => store.reason.data.map(
        ({ id, description }) => ({
            label: description,
            id,
        })
    ))

    const formFieldsToReset = {
        amount: '', comments: '', companyId: 0, currencyId: 0, documentDate: null,
            documentNumber: '', exchangeRate: '', supplierCUIT: '', otherSupports: '',
            reasonId: 0, relatedInvoice: ''
      };

    const handleClickEditCuit = () => {
        setFieldValue('supplierCUIT', '')
        setEditCuit(!editCuit);
    }

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClearValues = () => {
        setRelatedInvoice("")
        setAllRelatedInvoice([])
        setFieldValue(Object.assign(values, { relatedInvoice: '' }))
        setDisabledRelatedInvoice(false);
    }

    React.useEffect(() => {
        if (allRelatedInvoice && allRelatedInvoice.length > 0) {
            setFieldValue(Object.assign(values, { relatedInvoice: allRelatedInvoice.join(" / ") }))
        }
    }, [relatedInvoice])

    React.useEffect(() => {
        if (email) {
            setFieldValue("supplierEmail", email)
            if (values.supplierCUIT === '' && availablesCUIT.length === 1)
                setFieldValue("supplierCUIT", availablesCUIT[0].cuit)
        }

        if (availablesCUIT.length > 0 && (values?.supplierCUIT === '' || (values?.supplierCUIT !== '' && availablesCUIT.some(item => item.cuit === values?.supplierCUIT))))
            setEditCuit(true)
    }, [])

    React.useEffect(() => {
        if (availablesCUIT.length === 0) {
            enqueueSnackbar(`No se ha podido obtener CUIT asociado al email del proveedor. Completelo por favor.`, { variant: "error", action: snackAction, autoHideDuration: 2000 });
        }
    }, [])

    React.useEffect(() => {
        if (currencies.length === 0) { dispatch(getCurrencies()) }
        if (reasons.length === 0) { dispatch(getReasons()) }

    }, [currencies.length, dispatch, reasons.length])

    React.useEffect(() => {

        if (validateXmlInvoice && values && values.otherSupports !== '') {

            const currencyId = currencies.find(currency => currency.label === xmlValues.currencyType)
            const companyId = societies.find(society => society.label.split(' -')[0] === xmlValues.companyToBillTaxId)

            setFieldValue(Object.assign(values, {
                amount: xmlValues.amount.toString(), companyId: companyId?.id, currencyId: currencyId?.id,
                documentDate: new Date(xmlValues.documentDate), documentNumber: xmlValues.documentNumber, exchangeRate: xmlValues.exchangeRate.toString()
            }))

            if (values.documentTypeId === 5) {
                setFieldValue(Object.assign(values, { relatedInvoice: xmlValues.cfdI_UUID_REL }))
            }

            if (values.supplierCUIT === '' && !availablesCUIT.some(item => item.cuit === values.supplierCUIT)) {
                setFieldValue(Object.assign(values, { supplierCUIT: xmlValues.supplierTaxId }))
            }

            let currency = currencies.find(x => x.id === values?.currencyId)
            if (country && country?.id !== currency?.countryId) {
                setFieldValue(Object.assign(values, { exchangeRate: xmlValues.exchangeRate.toString() }))
            } else {
                setFieldValue('exchangeRate', '1')
                setExchangeRateDisabled(true)
            }
        }
    }, [xmlValues])

    React.useEffect(() => {
        if (validateXmlInvoice && values.otherSupports !== '') {
            setXmlValuesDisabled(true)
        } else if (validateXmlInvoice && values.otherSupports === '') {
            setXmlValuesDisabled(false)
        }
    }, [country, values])

    const onDrop = (cfiles, documentTypeId) => {
        let formData = new FormData();
        formData.append("attachmentXml", cfiles[0])

        dispatch(postSendDocumentXml(formData, documentTypeId,country?.id)).then(res => {
            enqueueSnackbar(`Documento cargado correctamente`, { variant: "success", action: snackAction, autoHideDuration: 2000 });
        })
            .catch((err) => {
                //console.log('err', err)
                enqueueSnackbar("No hemos podido procesar el archivo XML. Por favor, envíe un Email al equipo de CUPA (suppliercc@cloud.techint.com).", {
                    variant: "error",
                    action: snackAction,
                    autoHideDuration: 4000,
                });
                for (const fieldName in formFieldsToReset) {
                    setFieldValue(fieldName, formFieldsToReset[fieldName]);
                  }
            });
        setFieldValue("otherSupports", cfiles)
    }

    const getListValidationErrors = errors => {
        return <div><ul>
            {
                errors?.map(err => <li>{err}</li>)
            }
        </ul></div>
    }

    const handleDelete = () => {
        setFieldValue(Object.assign(values, formFieldsToReset))
        setXmlValuesDisabled(false)
        setDisabledRelatedInvoice(false);
        setAllRelatedInvoice([])
    }

    const handleEmptyRate = (value) => {
        if (country && country?.id === value?.countryId) {
            setFieldValue('exchangeRate', '1')
            setExchangeRateDisabled(true)
        } else if (country) {
            setFieldValue('exchangeRate', '')
            setExchangeRateDisabled(false)
        }
    }
    const isProveedoresExterior = documentType =="Factura Proveedores Exterior"
    
    return (
        <Grid container spacing={2}>

            {validateXmlInvoice && !isProveedoresExterior?
                <Grid item xs={12} marginTop={2}>
                    <Dropzone onDrop={(cfiles) => onDrop(cfiles, values.documentTypeId)} maxFiles={1} accept="text/xml">
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div {...getRootProps({ className: "dropzone dropzone__xml" })}>
                                    <input name="attachmentXml" {...getInputProps()} />
                                    {values?.otherSupports &&
                                        Array.isArray(values.otherSupports) &&
                                        values.otherSupports.length ? (
                                        <div className="selected-file">
                                            <div><Chip style={{ marginTop: "15px" }} label={values.otherSupports[0].name} variant="outlined" onDelete={() => handleDelete()} /></div>
                                            <div>
                                                <p style={{ color: "orange", fontWeight: "bold", fontSize: "15px", marginLeft: "200px", marginRight: "200px" }}>
                                                    Por favor validar si la información es correcta sino deberá revisar/re-cargar el .xml que se adjunto
                                                </p>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <p style={{ color: "orange", fontWeight: "bold", fontSize: "15px" }}>
                                                Para Proveedor de {country?.longName} adjuntar .XML aquí
                                            </p>
                                            <BackupIcon />
                                            <p>Arrastre el archivo aquí o <u> explore</u></p>
                                        </>
                                    )}
                                </div>
                                <aside className="selected-file-wrapper"></aside>
                            </section>
                        )}
                    </Dropzone>
                </Grid>
            : null}
            <Grid item xs={6} marginTop={2}>
                <Field
                    type="select"
                    name="companyId"
                    label="Sociedad Techint a Facturar"
                    component={FormikAutocomplete}
                    options={societies}
                    disabled={xmlValuesDisabled}
                />
            </Grid>
            <Grid item xs={6} marginTop={2}>
                <Field
                    type="select"
                    name="supplierEmail"
                    label="Email Proveedor"
                    disabled
                    component={FormikInputTest}
                    style={{ width: "100%" }}
                />
            </Grid>
            {
                editCuit && (values.supplierCUIT === '' || (values.supplierCUIT !== '' && availablesCUIT.some(item => item.cuit === values.supplierCUIT))) ?
                    <Grid item xs={7}>
                        <Field
                            type="select"
                            name="supplierCUIT"
                            label="NIF / RFC / CUIT Proveedor"
                            component={FormikAutocomplete}
                            options={availablesCUIT.map(
                                (data) => ({
                                    label: `${data.cuit} - ${data.supplierDescription ?? ''}`,
                                    id: data.cuit,
                                })
                            )}
                            disabled={xmlValuesDisabled}
                        />
                    </Grid> :
                    <Grid item xs={availablesCUIT.length > 0 ? 7 : 8} >
                        <TextFieldWithEraser
                            fullWidth
                            label='NIF / RFC / CUIT Proveedor'
                            value={values?.supplierCUIT}
                            regExp={/^[A-Za-z0-9]+$/}
                            onChange={value => setFieldValue('supplierCUIT', value)}
                            disabled={xmlValuesDisabled}
                            xmlValuesDisabled={xmlValuesDisabled}
                        />
                    </Grid>
            }
            {
                !xmlValuesDisabled && availablesCUIT.length > 0 &&
                <Grid item xs={1}>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={() => handleClickEditCuit()}
                        className={classes.button}
                    >
                        {editCuit && (values.supplierCUIT === '' || (values.supplierCUIT !== '' && availablesCUIT.some(item => item.cuit === values.supplierCUIT))) ? 'Edit' : 'Cancel'}
                    </Button>
                </Grid>
            }

            <Grid item xs={4}>
                <Field
                    //type="select"
                    name="purchaseOrderNumber"
                    label="Número Orden de Compra"
                    component={FormikInputTest}
                    style={{ width: "100%" }}
                />
            </Grid>

            <Grid item xs={3}>

                <TextFieldWithEraser
                    fullWidth
                    label={`Nro ${documentType.toUpperCase() === "ANTICIPO" ? "Factura" : documentType}`}
                    value={values?.documentNumber}
                    regExp={DOCUMENT_INVOICE_MASK[country?.name]?.regexInput}
                    onChange={value => setFieldValue('documentNumber', value)}
                    placeholder={DOCUMENT_INVOICE_MASK[country?.name]?.placeholder}
                    disabled={xmlValuesDisabled}
                    xmlValuesDisabled={xmlValuesDisabled}
                />
            </Grid>

            <Grid item xs={2} >
                <FormikDataPicker
                    name="documentDate"
                    disabled={xmlValuesDisabled}
                    xmlValuesDisabled={xmlValuesDisabled}
                />
            </Grid>

            <Grid item xs={2} >
                <Field
                    type="select"
                    name="currencyId"
                    label="Moneda"
                    component={FormikAutocomplete}
                    options={currencies}
                    handleEmptyRate={handleEmptyRate}
                    disabled={xmlValuesDisabled}
                />
            </Grid>
            <Grid item xs={2}>
                <Field
                    type="select"
                    name="exchangeRate"
                    label="Tipo de cambio"
                    disabled={!xmlValues ? exchangeRateDisabled : xmlValuesDisabled}
                    component={FormikInputTest}
                    style={{ width: "100%" }}
                />
            </Grid>
            <Grid item xs={3}>
                <Field
                    type="select"
                    name="amount"
                    label="Importe"
                    component={FormikInputTest}
                    style={{ width: "100%" }}
                    disabled={xmlValuesDisabled}
                />
            </Grid>
            {
                documentType === 'Nota Crédito' && (<>
                    <Grid item xs={4}>
                        <Field
                            type="select"
                            name="reasonId"
                            label="Motivo"
                            component={FormikAutocomplete}
                            options={reasons}
                        />
                    </Grid>
                    <Grid item xs={6.8}>
                        <Field
                            type="select"
                            name="relatedInvoice"
                            label="Facturas relacionadas"
                            component={FormikInputTest}
                            style={{ width: "100%" }}
                            disabled={xmlValuesDisabled || disabledRelatedInvoice}
                        />
                    </Grid>
                    <Grid item xs={1.2} marginTop={1} >
                        <IconButton color="primary" variant="contained" onClick={handleOpen} disabled={xmlValuesDisabled}>
                            <AddCircleOutlinedIcon />
                        </IconButton>
                        <IconButton color="error" variant="contained" onClick={handleClearValues} disabled={xmlValuesDisabled}>
                            <CancelIcon />
                        </IconButton>
                        <RelatedInvoicePopup
                            open={open}
                            relatedInvoice={relatedInvoice}
                            allRelatedInvoice={allRelatedInvoice}
                            setOpen={setOpen}
                            setRelatedInvoice={setRelatedInvoice}
                            setAllRelatedInvoice={setAllRelatedInvoice}
                            setDisabledRelatedInvoice={setDisabledRelatedInvoice}
                        />
                    </Grid>
                </>
                )
            }
            <Grid item xs={12}>
                <Field
                    type="select"
                    name="comments"
                    label="Comentarios"
                    component={FormikInputTest}
                    style={{ width: "100%" }}
                />
            </Grid>

        </Grid>
    )
}

export default CompanyToInvoice